import locationEditComponent from './location.edit.component';

let locationEditModule = angular.module('locationedit', [
])

.component('locationedit', locationEditComponent)

.name;

export default locationEditModule;


// WEBPACK FOOTER //
// ./client/app/components/location/edit/index.js